<template>
  <!-- 
    @Author shirleywanghui@didichuxing.com
    @Date 2022-04-26
    @Description cgc推荐页改版 - 子组件 - banner
  -->
  <div class="banner">
    <div v-if="isOpenHorseLamp" class="xtc-recommend-horselamp-swiper">
      <van-swipe style="height: 30px;" :loop="true" autoplay="2000" vertical :show-indicators="false" @swipe-indicator-active-opacity="0.9">
        <van-swipe-item v-for="(item,index) in horseLampData" :key="index">
          <RecommendHorseLampItem
          class="margin-right-30 padding-10"
          :img="item.headImage"
          :name="item.nickName"
          :amount="item.display"
          />
        </van-swipe-item>
      </van-swipe>
    </div>

    <p class="history" @click="$emit('gotoRewardList', true)" v-if="showMyRewardsHistory">{{_('我的奖励')}}</p>
    <rich-slide ref="slide" :data="list">
      <rich-slide-item v-for="(item, index) in list" :key="index">
        <div class="slide-item">
          <span class="mainTitle">{{item.title}}</span>
          <span class="subTitle">{{item.subTitle}}</span>
          <img :src="item.url" />
        </div>
      </rich-slide-item>
      <template slot="dots" slot-scope="props">
        <template v-if="props.dots.length > 1">
          <span
            class="my-dot"
            :class="{active: props.current === index}"
            v-for="(item, index) in props.dots"
            :key="index"
          >{{index + 1}}</span>
        </template>
        <span class="my-dot" v-else style="display:none"></span>
      </template>
    </rich-slide>
  </div>
</template>
<script>
import Vue from 'vue'
import { Swipe, SwipeItem } from 'vant'
import RecommendHorseLampItem from './recommend_horselamp_item'
Vue.use(Swipe)
Vue.use(SwipeItem)
export default {
  props: {
    list: {
      required: true,
      default: () => []
    },
    showMyRewardsHistory: {
      type: Boolean,
      default: false
    },
    isOpenHorseLamp: {
      type: Boolean,
      default: false
    },
    horseLampData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    RecommendHorseLampItem
  }
}
</script>
<style scoped lang="stylus">
.xtc-recommend-horselamp-swiper {
  position: absolute;
  bottom: 26px;
  left: 10px;
  z-index: 100;
  height: 48px !important;
  overflow: hidden;
}
.banner {
  margin-bottom: 18px;
  overflow: hidden
  width: 100%
  max-height: 430px;
  background-color: #f5f5f5
  position relative
  .slide-item {
    max-height: 430px;
    position: relative
    .mainTitle {
      display: none
      position: absolute
      left: 10px
      bottom: 50px
    }
    .subTitle {
      display: none
      position: absolute
      left: 10px
      bottom: 10px
      font-size: 28px
    }
    img {
      width: 100%
    }
  }
  .rich-slide-dots {
    .my-dot {
      width: 20px
      height: 4px
      opacity: 0.24
      background: #FFFFFF
      border-radius: 4px
    }
    .active {
      width: 20px
      opacity: 0.66
    }
  }
  .errStatus {
    overflow: hidden
    width: 100%
    height: 430px
    background-size: 100%;
    text-align: center
    strong{
      margin: 200px auto 0
      display: block
    }
  }
  .history {
    position absolute
    z-index 10
    right 0
    top 25px
    padding 0 24px
    height 56px
    line-height 56px
    opacity: 0.36;
    background: #000000;
    border-radius: 8px 0 0 8px;
    font-family: 'Aspira Medium';
    font-size: 28px;
    color: #FFFFFF;
    text-align: left;
    text-shadow: 0 0 24px rgba(0,0,0,0.36);
  }
}
</style>